export function PricingModal({ prices, isSaving, preventMinus, onClose, onSubmit }) {
  return (
    <div className="modal-overlayAdmin">
      <div className="modal-contentAdmin">
        <div className="modal-headerEvent">
          <h3>Update pricing</h3>
          <button
            className="close-button"
            onClick={onClose}
          >
            &times;
          </button>
        </div>
        <form onSubmit={onSubmit}>
          <div className="pricing-edit-list">
            <div className="pricing-edit-row">
              <label>
                Primary • <span>Group weekdays</span>
              </label>
              <input
                name="primary_group_weekdays"
                type="number"
                min="1"
                onKeyDown={preventMinus}
                defaultValue={prices.primary_group_weekdays}
              />
            </div>
            <div className="pricing-edit-row">
              <label>
                Primary • <span className="weekend-text">Group weekends</span>
              </label>
              <input
                name="primary_group_weekends"
                type="number"
                min="1"
                onKeyDown={preventMinus}
                defaultValue={prices.primary_group_weekends}
              />
            </div>
            <div className="pricing-edit-row">
              <label>
                Secondary • <span>Group weekdays</span>
              </label>
              <input
                name="secondary_group_weekdays"
                type="number"
                min="1"
                onKeyDown={preventMinus}
                defaultValue={prices.secondary_group_weekdays}
              />
            </div>
            <div className="pricing-edit-row">
              <label>
                Secondary • <span className="weekend-text">Group weekends</span>
              </label>
              <input
                name="secondary_group_weekends"
                type="number"
                min="1"
                onKeyDown={preventMinus}
                defaultValue={prices.secondary_group_weekends}
              />
            </div>
            <div className="pricing-edit-row">
              <label>
                Primary • <span translate="no">1v1</span>
              </label>
              <input
                name="primary_1v1"
                type="number"
                min="1"
                onKeyDown={preventMinus}
                defaultValue={prices.primary_1v1}
              />
            </div>
            <div className="pricing-edit-row">
              <label>
                Secondary • <span translate="no">1v1</span>
              </label>
              <input
                name="secondary_1v1"
                type="number"
                min="1"
                onKeyDown={preventMinus}
                defaultValue={prices.secondary_1v1}
              />
            </div>
            <div className="pricing-edit-row">
              <label>
                Cegep • <span translate="no">1v1</span>
              </label>
              <input
                name="college_1v1"
                type="number"
                min="1"
                onKeyDown={preventMinus}
                defaultValue={prices.college_1v1}
              />
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn-cancel"
              onClick={onClose}
            >
              <span>Cancel</span>
            </button>
            <button type="submit" className="btn-save" disabled={isSaving}>
              <span>{isSaving ? "Processing..." : "Save changes"}</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
